import React, { useEffect, useState } from 'react'
import Profile from '../../../../assets/images/default-placeholder.png'
import { Icon } from '@iconify/react'
import { useLocation } from 'react-router-dom'
import { InputField } from '../../../../components'
import TextAreaField from '../../../../components/Form/TextArea'
import { getPersonalInfo, updatePersonalInfo, getAllStates } from '../api'
import { Button } from 'react-bootstrap'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { formatDate } from '../../../resources/empresources/utils/index'
import {
    getLookupValue,
    getLocationNameById,
    findManagerById,
    getOptions,
    getLocationOptions,
} from '../utils/index'
import { getUserLocationbased } from '../../../../features/userslisting/createuser/api'
import { useAppDispatch, useAppSelector } from '../../../../redux/hook'
import { HIDE_LOADER, SHOW_LOADER } from '../../../../redux/slices/LoaderSlice'
import SelectField from '../../../../components/Form/Select'
import { SHOW_NOTIFICATION } from '../../../../redux/slices/showNotificationSlice'
import {
    State,
    Gender,
    IdsTypes,
    lookUpTypesI,
    PaginatedDataLocationLookup,
} from '../../type'
import camera from '../../../../assets/svg/icon-camera.svg'
import '../../createuser/pages/index.css'
import { convertDateFormat } from '../../../holidays/utils'
import { User } from '../../../auth/slice/userSlice'
import { MAX_CHAR_COUNT } from '../../../../utils/index'

const Personalinfo: React.FC<{
    lookupValues: lookUpTypesI[]
    locationsLookupValues: PaginatedDataLocationLookup | null
    setUserId: (value: string) => void
    isActive: boolean
    setUserLeavePolicyId: (value: string) => void
}> = ({
    lookupValues,
    locationsLookupValues,
    setUserId,
    isActive,
    setUserLeavePolicyId,
}) => {
    const location = useLocation()
    const dispatch = useAppDispatch()
    const userProfileState = useAppSelector(
        (state) => state.persistedReducers.user
    )
    const params = new URLSearchParams(location.search)
    const otherUserId = params.get('userId')
    const { role, locationId } = useAppSelector(
        (state) => state.persistedReducers.user
    )
    const [userRole, setUserRole] = useState<string>('')
    const [toggle, setToggle] = useState<boolean>(false)
    const [states, setStates] = useState<State[]>([])
    const [ids, setIds] = useState<IdsTypes>({
        userId: null,
        genderId: null,
        stateId: null,
        assignedManagerId: null,
        countryId: null,
        dateOfBirth: null,
    })
    const [genderTypeOptions, setGenderTypeOptions] = useState<Gender[]>([])
    const [locationOptions, setLocationOptions] = useState<Gender[]>([])
    const [managerOptions, setManagerOptions] = useState<Gender[]>([])
    const [image, setImage] = useState<{
        name: string
        extension: string
        data: string | ArrayBuffer | null
    }>({
        name: '',
        extension: '',
        data: null,
    })
    const [imagePreview, setImagePreview] = useState<string | null>(null)

    const validationSchema = Yup.object().shape({
        firstname: Yup.string().required('First name is required'),
    })

    const formik = useFormik({
        initialValues: {
            firstname: '',
            lastname: '',
            middlename: '',
            address: '',
            country: 'Canada',
            state: '',
            manager: managerOptions[0]?.value ? managerOptions[0]?.value : '',
            gender: '',
            birthday: '',
            postalcode: '',
            availability: '',
        },
        validationSchema: validationSchema,
        onSubmit: async (values, { setSubmitting }) => {
            const genderOption = genderTypeOptions.find(
                (option: any) => option.label === formik.values.gender
            )
            const genderId = genderOption ? genderOption.value : null

            const stateOption = locationOptions.find(
                (option: any) => option.label === formik.values.state
            )

            const statesId = stateOption ? stateOption.value : null

            const managerOption = managerOptions.find(
                (option: any) => option.label === formik.values.manager
            )
            const managerId = managerOption ? managerOption.value : null

            dispatch(SHOW_LOADER())
            try {
                const requestBody = {
                    image:
                        image?.name !== ''
                            ? {
                                  name: image?.name,
                                  data: image?.data,
                                  extension: image?.extension,
                              }
                            : null,
                    userId: ids?.userId,
                    firstName: formik.values.firstname,
                    middleName: formik.values.middlename,
                    lastName: formik.values.lastname,
                    genderId: genderId,
                    dateOfBirth: formik.values.birthday,
                    address: formik.values.address,
                    countryId: ids?.countryId,
                    stateId: statesId,
                    postalCode: formik.values.postalcode,
                    assignedManagerId: managerId,
                    availability: formik.values.availability,
                }
                const response = await updatePersonalInfo(requestBody)
                if (response.status === 200) {
                    dispatch(
                        SHOW_NOTIFICATION({
                            message: 'Profile updated successfully',
                            type: 'success',
                        })
                    )
                    if (requestBody?.image !== null && !otherUserId) {
                        const params = {
                            userId: otherUserId,
                        }

                        const userPersonalProfile =
                            await getPersonalInfo(params)
                        dispatch(
                            User({
                                role: userProfileState.role,
                                firstName: userProfileState.firstName,
                                email: userProfileState.email,
                                id: userProfileState.id,
                                lastName: userProfileState.lastName,
                                image: userPersonalProfile.data.imageUrl
                                    ? userPersonalProfile.data.imageUrl
                                    : null,
                                locationId: userProfileState.locationId,
                                leavePolicyId: userProfileState.leavePolicyId,
                            })
                        )
                    }
                }
            } catch (error) {
                console.error('Error updating personal info:', error)
            } finally {
                setToggle(false)
                dispatch(HIDE_LOADER())
                setSubmitting(false)
            }
        },
    })

    useEffect(() => {
        const getPersonalInformation = async () => {
            dispatch(SHOW_LOADER())
            if (isActive === true) {
                try {
                    const params = {
                        userId: otherUserId,
                    }
                    const states = await getAllStates()
                    const response = await getPersonalInfo(params)
                    setStates(states?.data)
                    setIds({ ...ids, countryId: states?.data?.countryId })
                    const {
                        firstName,
                        lastName,
                        address,
                        dateOfBirth,
                        postalCode,
                        availability,
                        genderId,
                        stateId,
                        assignedManagerId,
                        userId,
                        countryId,
                        middleName,
                        imageUrl,
                        role,
                        leavePolicyId,
                    } = response?.data || {}
                    setIds({
                        userId,
                        genderId,
                        stateId,
                        assignedManagerId,
                        countryId,
                        dateOfBirth,
                    })
                    setUserLeavePolicyId(leavePolicyId)
                    setImagePreview(imageUrl)
                    setUserRole(role)
                    setUserId(userId)
                    formik.setFieldValue('firstname', firstName)
                    formik.setFieldValue('middlename', middleName)
                    formik.setFieldValue('postalcode', postalCode)
                    formik.setFieldValue(
                        'birthday',
                        convertDateFormat(dateOfBirth)
                    )
                    formik.setFieldValue('address', address)
                    formik.setFieldValue('lastname', lastName)
                    formik.setFieldValue('availability', availability)
                    formik.setFieldValue('country', 'Canada')
                    formik.setFieldValue(
                        'gender',
                        getLookupValue(lookupValues, 'Gender', genderId)
                    )
                    formik.setFieldValue(
                        'state',
                        getLocationNameById(states?.data, stateId)
                    )
                    if (role !== 'Admin' && locationId) {
                        const locationBasedManager =
                            await getUserLocationbased(locationId)
                        const managerOptionsValues =
                            locationBasedManager?.data?.map((manager: any) => ({
                                label: `${manager.firstName} ${manager.lastName}`,
                                value: manager.id,
                            }))

                        setManagerOptions(managerOptionsValues)
                        if (locationBasedManager?.data) {
                            await formik.setFieldValue(
                                'manager',
                                findManagerById(
                                    locationBasedManager?.data,
                                    assignedManagerId
                                )
                            )
                        }
                    } else {
                        setManagerOptions([])
                    }
                } catch (err) {
                    console.error('Error fetching', err)
                } finally {
                    dispatch(HIDE_LOADER())
                }
            }
        }
        if (
            (location.pathname === '/profile' ||
                location.pathname === '/users/view') &&
            isActive === true &&
            lookupValues?.length !== 0
        ) {
            getPersonalInformation()
        }
    }, [lookupValues, otherUserId, isActive])

    useEffect(() => {
        setGenderTypeOptions(getOptions(lookupValues, 'Gender'))
        setLocationOptions(getLocationOptions(states))
    }, [lookupValues, states])

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0] // Get the first selected file
        if (file) {
            const reader = new FileReader()
            reader.onloadend = () => {
                const imageDataUrl = reader.result as string // Convert result to base64 string
                setImagePreview(imageDataUrl)
                const name = file.name
                const extension = name.split('.').pop() || '' // Get file extension
                setImage({
                    name: name,
                    extension: `.${extension}`,
                    data: imageDataUrl,
                })
            }
            reader.readAsDataURL(file) // Read the file as a data URL
        }
    }

    return (
        <div>
            <div className="user-form">
                <form onSubmit={formik.handleSubmit}>
                    <div className="prof-info">
                        <div className="row d-flex align-items-center ">
                            <div className="col-sm-8">
                                {location.pathname === '/profile' && (
                                    <div className="d-flex align-items-center profile-img">
                                        <div className="upload-box-img">
                                            <img
                                                src={
                                                    imagePreview
                                                        ? imagePreview
                                                        : Profile
                                                }
                                                alt="Logo"
                                                className="icon-profile"
                                            />
                                            <label
                                                className="file file--uploading"
                                                htmlFor="input-file"
                                            >
                                                <input
                                                    id="input-file"
                                                    type="file"
                                                    onChange={handleFileChange}
                                                    disabled={!toggle}
                                                />
                                                {toggle && (
                                                    <img
                                                        src={camera}
                                                        alt="Logo"
                                                        className="icon-camera"
                                                    />
                                                )}
                                            </label>
                                        </div>
                                        <div className="user-overview">
                                            <h4>
                                                {formik?.values?.firstname}{' '}
                                                {formik?.values?.middlename
                                                    ? formik?.values?.middlename
                                                    : ''}{' '}
                                                {formik?.values?.lastname}
                                            </h4>
                                            <h6>{userRole}</h6>
                                            <h6>
                                                {locationId &&
                                                    locationsLookupValues &&
                                                    getLocationNameById(
                                                        locationsLookupValues?.data,
                                                        locationId
                                                    )}
                                                {locationId ? ',' : '-- ,'}{' '}
                                                Canada
                                            </h6>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="col-sm-4">
                                <div className="custom-btn-design btns-block">
                                    <div className="dropdown-custom-link">
                                        {!toggle && (
                                            <Icon
                                                onClick={() => {
                                                    setToggle(true)
                                                }}
                                                icon="bx:edit"
                                                className="icon-primary"
                                                cursor={'pointer'}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row mt-2">
                            <div className="col-sm-5">
                                <div className="form-group mb-3">
                                    {!toggle ? (
                                        <>
                                            {' '}
                                            <label>First Name</label>
                                            <p>
                                                {formik.values.firstname === ''
                                                    ? '--'
                                                    : formik.values.firstname}
                                            </p>
                                        </>
                                    ) : (
                                        <div className="bg-green-color">
                                            <InputField
                                                type="text"
                                                lable={'First Name'}
                                                name="firstname"
                                                value={formik.values.firstname}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                error={formik.errors.firstname}
                                                touched={
                                                    formik.touched.firstname
                                                }
                                                // defaultValue={
                                                //     formik.values.firstname
                                                // }
                                                placeholder=""
                                            />
                                        </div>
                                    )}
                                </div>
                                <div className="form-group mb-3">
                                    {!toggle ? (
                                        <>
                                            {' '}
                                            <label>Middle Name</label>
                                            <p>
                                                {formik.values.middlename ===
                                                    '' ||
                                                formik.values.middlename ===
                                                    null
                                                    ? '--'
                                                    : formik.values.middlename}
                                            </p>
                                        </>
                                    ) : (
                                        <div className="bg-green-color">
                                            <InputField
                                                type="text"
                                                lable={'Middle Name'}
                                                name="middlename"
                                                value={formik.values.middlename}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                error={formik.errors.middlename}
                                                touched={
                                                    formik.touched.middlename
                                                }
                                            />
                                        </div>
                                    )}
                                </div>
                                <div className="form-group mb-3">
                                    {!toggle ? (
                                        <>
                                            {' '}
                                            <label>Last Name</label>
                                            <p>
                                                {formik.values.lastname === ''
                                                    ? '--'
                                                    : formik.values.lastname}
                                            </p>
                                        </>
                                    ) : (
                                        <div className="bg-green-color">
                                            <InputField
                                                type="text"
                                                lable={'Last Name'}
                                                name="lastname"
                                                value={formik.values.lastname}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                error={formik.errors.lastname}
                                                touched={
                                                    formik.touched.lastname
                                                }
                                            />
                                        </div>
                                    )}
                                </div>
                                <div className="form-group mb-3">
                                    {!toggle ? (
                                        <>
                                            {' '}
                                            <label>Gender</label>
                                            <p>
                                                {formik.values.gender === ''
                                                    ? '--'
                                                    : formik.values.gender}
                                            </p>
                                        </>
                                    ) : (
                                        <div className="bg-green-color">
                                            <SelectField
                                                label={'Gender'}
                                                name="gender"
                                                options={[
                                                    {
                                                        label: 'Select',
                                                        value: '',
                                                    },
                                                    ...genderTypeOptions,
                                                ]}
                                                value={
                                                    genderTypeOptions.find(
                                                        (option: any) =>
                                                            option.label ===
                                                            formik.values.gender
                                                    )?.value || ''
                                                }
                                                onChange={(event: any) => {
                                                    const selectedOption =
                                                        genderTypeOptions.find(
                                                            (option: any) =>
                                                                option.value ===
                                                                event.target
                                                                    .value
                                                        )
                                                    formik.setFieldValue(
                                                        'gender',
                                                        selectedOption
                                                            ? selectedOption.label
                                                            : ''
                                                    )
                                                }}
                                                onBlur={formik.handleBlur}
                                                error={formik.errors.gender}
                                                touched={formik.touched.gender}
                                                defaultValue="option1"
                                            />
                                        </div>
                                    )}
                                </div>
                                <div className="form-group mb-3">
                                    {!toggle ? (
                                        <>
                                            {' '}
                                            <label>Birthday</label>
                                            <p>
                                                {formik.values.birthday ===
                                                    '' ||
                                                formik.values.birthday === null
                                                    ? '--'
                                                    : formatDate(
                                                          formik.values.birthday
                                                      )}
                                            </p>
                                        </>
                                    ) : (
                                        <div className="bg-green-color">
                                            <InputField
                                                type="date"
                                                name="birthday"
                                                lable="Birthday"
                                                value={formik.values.birthday}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                error={formik.errors.birthday}
                                                touched={
                                                    formik.touched.birthday
                                                }
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="col-sm-5">
                                <div className="form-group mb-3">
                                    {!toggle ? (
                                        <>
                                            {' '}
                                            <label>Address</label>
                                            <p>
                                                {formik.values.address === '' ||
                                                formik.values.address === null
                                                    ? '--'
                                                    : formik.values.address}
                                            </p>
                                        </>
                                    ) : (
                                        <div className="bg-green-color">
                                            <InputField
                                                type="text"
                                                lable={'Address'}
                                                name="address"
                                                value={formik.values.address}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                error={formik.errors.address}
                                                touched={formik.touched.address}
                                            />
                                        </div>
                                    )}
                                </div>
                                <div className="form-group mb-3">
                                    {!toggle ? (
                                        <>
                                            {' '}
                                            <label>Country</label>
                                            <p>
                                                {formik.values.country === ''
                                                    ? '--'
                                                    : formik.values.country}
                                            </p>
                                        </>
                                    ) : (
                                        <div className="bg-green-color">
                                            <SelectField
                                                name="country"
                                                label="Country"
                                                options={[
                                                    {
                                                        value: '',
                                                        label: 'Canada',
                                                    },
                                                ]}
                                                value={formik.values.country}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                error={formik.errors.country}
                                                touched={formik.touched.country}
                                            />
                                        </div>
                                    )}
                                </div>
                                <div className="form-group mb-3">
                                    {!toggle ? (
                                        <>
                                            {' '}
                                            <label>State/Province</label>
                                            <p>
                                                {formik.values.state === ''
                                                    ? '--'
                                                    : formik.values.state}
                                            </p>
                                        </>
                                    ) : (
                                        <div className="bg-green-color">
                                            <SelectField
                                                name="state"
                                                label={'State/Province'}
                                                options={[
                                                    {
                                                        label: 'Select',
                                                        value: '',
                                                    },
                                                    ...locationOptions,
                                                ]}
                                                value={
                                                    locationOptions.find(
                                                        (option: any) =>
                                                            option.label ===
                                                            formik.values.state
                                                    )?.value || ''
                                                }
                                                onChange={(event: any) => {
                                                    const selectedOption =
                                                        locationOptions.find(
                                                            (option: any) =>
                                                                option.value ===
                                                                event.target
                                                                    .value
                                                        )
                                                    formik.setFieldValue(
                                                        'state',
                                                        selectedOption
                                                            ? selectedOption.label
                                                            : ''
                                                    )
                                                }}
                                                onBlur={formik.handleBlur}
                                                error={formik.errors.state}
                                                touched={formik.touched.state}
                                            />
                                        </div>
                                    )}
                                </div>
                                <div className="form-group mb-3">
                                    {!toggle ? (
                                        <>
                                            {' '}
                                            <label>Postal Code</label>
                                            <p>
                                                {formik.values.postalcode ===
                                                    '' ||
                                                formik.values.postalcode ===
                                                    null
                                                    ? '--'
                                                    : formik.values.postalcode}
                                            </p>
                                        </>
                                    ) : (
                                        <div className="bg-green-color">
                                            <InputField
                                                type="text"
                                                lable={'Postal Code'}
                                                name="postalcode"
                                                value={formik.values.postalcode}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                error={formik.errors.postalcode}
                                                touched={
                                                    formik.touched.postalcode
                                                }
                                            />
                                        </div>
                                    )}
                                </div>
                                <div className="form-group mb-3">
                                    {!toggle ? (
                                        <>
                                            {' '}
                                            <label>Assigned Manager</label>
                                            <p>
                                                {formik.values.manager === '' ||
                                                formik.values.manager === null
                                                    ? '--'
                                                    : formik.values.manager}
                                            </p>
                                        </>
                                    ) : (
                                        role === 'Admin' ||
                                        (role === 'Executive Director' && (
                                            <div className="bg-green-color">
                                                <SelectField
                                                    label={'Assigned Manager'}
                                                    name="manager"
                                                    options={managerOptions}
                                                    value={
                                                        managerOptions.find(
                                                            (option: any) =>
                                                                option.label ===
                                                                formik.values
                                                                    .manager
                                                        )?.value || ''
                                                    }
                                                    onChange={(event: any) => {
                                                        const selectedOption =
                                                            managerOptions.find(
                                                                (option: any) =>
                                                                    option.value ===
                                                                    event.target
                                                                        .value
                                                            )
                                                        formik.setFieldValue(
                                                            'manager',
                                                            selectedOption
                                                                ? selectedOption.label
                                                                : ''
                                                        )
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                    error={
                                                        formik.errors
                                                            .manager as string
                                                    }
                                                    touched={
                                                        formik.touched
                                                            .manager as boolean
                                                    }
                                                />
                                            </div>
                                        ))
                                    )}
                                </div>
                            </div>

                            <div className="col-sm-10">
                                <div className="form-group mb-3">
                                    {!toggle ? (
                                        <>
                                            {' '}
                                            <label>Schedule</label>
                                            <pre>
                                                {formik.values.availability ===
                                                    '' ||
                                                formik.values.availability ===
                                                    null
                                                    ? '--'
                                                    : formik.values
                                                          .availability}
                                            </pre>
                                        </>
                                    ) : (
                                        role !== 'Teacher' && (
                                            <div className="bg-green-color">
                                                <TextAreaField
                                                    name="availability"
                                                    label="Schedule"
                                                    value={
                                                        formik.values
                                                            .availability
                                                    }
                                                    onChange={
                                                        formik.handleChange
                                                    }
                                                    onBlur={formik.handleBlur}
                                                    error={
                                                        formik.errors
                                                            .availability
                                                    }
                                                    touched={
                                                        formik.touched
                                                            .availability
                                                    }
                                                    rows={6}
                                                    maxLength={MAX_CHAR_COUNT}
                                                />
                                            </div>
                                        )
                                    )}
                                </div>
                            </div>
                            {toggle && (
                                <div className="row mt-4 mb-4">
                                    <div className="d-flex justify-content-between">
                                        <div></div>
                                        <div>
                                            <div className="button-block button-block-inline">
                                                <Button
                                                    className="button button-outline me-5 upload-cancel"
                                                    onClick={() =>
                                                        setToggle(false)
                                                    }
                                                >
                                                    CANCEL
                                                </Button>
                                                <Button
                                                    className="button button-primary "
                                                    type="submit"
                                                    // onClick={() =>
                                                    //     setToggle(false)
                                                    // }
                                                >
                                                    SAVE
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </form>
                <div className="space-100"></div>
            </div>
        </div>
    )
}

export default Personalinfo
